import React from 'react';
import {Button, DropdownItem, DropdownMenu, DropdownToggle, Form, Input, UncontrolledDropdown} from 'reactstrap';
import {I18n} from '../../I18n/components/users';
import {SUPER_ADMIN, USER_ROLES} from "../../helpers/constants";

const UsersControls = props => {
	const buttons = props.authority === SUPER_ADMIN ? (
		<Button
			color="primary"
			type="button"
			className="userlist-card__btn"
			onClick={props.addUserClick}
		>
			{I18n[props.lang].addUser}
		</Button>
	) : (
		<UncontrolledDropdown className="ml-2 userlist-card__btn">
			<DropdownToggle caret color="primary">
				{I18n[props.lang].addUser}
			</DropdownToggle>
			<DropdownMenu>
				<DropdownItem onClick={props.addUserClick}>{I18n[props.lang].newUser}</DropdownItem>
				<DropdownItem onClick={props.toggleUploadModal}>{I18n[props.lang].packageCreation}</DropdownItem>
			</DropdownMenu>
		</UncontrolledDropdown>
	);

	const filterByCompanies = props.companies.length === 1 ? (
		null
	) : (
		<Input
			className="userlist-card__input userlist-card__input-company"
			type="select"
			name="companyId"
			id="companyId"
			onChange={props.onFilterClick('companyId')}
			value={props.companyId}
		>
			<option value="">{I18n[props.lang].company}</option>
			<option value="">{I18n[props.lang].all}</option>
			{
				props.companies ? (
					props.companies.map((company, i) => {
						return (
							<option value={company.id} key={i}>{company.name}</option>
						)
					})
				) : (
					<option value="">{I18n[props.lang].all}</option>
				)
			}
		</Input>
	);

	return (
		<div>
			<div className="userlist-card">
				<section>
					<Input
						className="userlist-card__input"
						type="select"
						name="status"
						id="status"
						value={props.status}
						onChange={props.onFilterClick('status')}
					>
						<option value="">{I18n[props.lang].statusAll}</option>
						{/*<option value="">{I18n[lang].all}</option>*/}
						<option value="NOT_APPROVED">{I18n[props.lang].statusPending}</option>
						<option value="ACTIVE">{I18n[props.lang].statusActive}</option>
						<option value="BLOCKED">{I18n[props.lang].statusBlocked}</option>
					</Input>
					<Input
						className="userlist-card__input"
						type="select"
						name="role"
						id="role"
						value={props.role}
						onChange={props.onFilterClick('role')}
					>
						<option value="">{I18n[props.lang].roleAll}</option>
						{/*<option value="">{I18n[lang].all}</option>*/}
						<option value="GUEST">{I18n[props.lang].roleGuest}</option>
						<option value="USER">{I18n[props.lang].roleUser}</option>
						<option value="COMPANY_ADMIN">{I18n[props.lang].roleCompanyAdmin}</option>
						{props.authority === USER_ROLES.SUPER_ADMIN ?
							<option value="SUPER_ADMIN">{I18n[props.lang].roleSuperAdmin}</option> : ""
						}
					</Input>
					{/*<Input*/}
					{/*	className="userlist-card__input"*/}
					{/*	type="select"*/}
					{/*	name="activity"*/}
					{/*	id="activity"*/}
					{/*	value={props.order}*/}
					{/*	onChange={props.onFilterClick('order')}*/}
					{/*>*/}
					{/*	<option value="">{I18n[props.lang].order}</option>*/}
					{/*	<option value="ASC">{I18n[props.lang].asc}</option>*/}
					{/*	<option value="DESC">{I18n[props.lang].desc}</option>*/}
					{/*</Input>*/}
					{ filterByCompanies }
					<Button color="secondary" className="ml-1 userlist-card__btn" onClick={props.clearFilters}>{I18n[props.lang].resetFilters}</Button>
				</section>
				{ buttons }
			</div>
			<Form className="userlist-searchform">
				<Input
					type="text"
					name="search"
					id="search"
					value={props.filter}
					onChange={props.onFilterClick('filter')}
					placeholder={I18n[props.lang].searchPlaceholder}
				/>
			</Form>
		</div>
	)
};

export default UsersControls;



// WEBPACK FOOTER //
// ./src/components/Users/UsersControls.js